import { render, staticRenderFns } from "./AwardWinners.vue?vue&type=template&id=f76422ac"
import script from "./AwardWinners.vue?vue&type=script&lang=js"
export * from "./AwardWinners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports